import React, { useEffect, useState } from 'react';
import { fetchData, postData, deleteData, activateData, updateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useParams, useHistory } from 'react-router-dom';

const EditUserProfile = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const history = useHistory();

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        setUpdateData((prevData) => ({
            ...prevData ,
            UpdatedBy : 1,
            [name]:
                name === "Gender"
                    ? value === "1" // convert string to boolean
                    : type === "checkbox"
                        ? checked
                        : value,
        }));
    };

    const fetchtableData = async () => {
        const companyId = 1;
        try {
            const response = await fetchData('UserApi', `/LoggedUserData/${id}`);
            if (response.responseCode === '1111') {
                console.log(response.response_data);
                setUpdateData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Subscription Plans Details:', error);
        }
    };

    useEffect(() => {
        fetchtableData();
    }, []);

    const [updatedData, setUpdateData] = useState({});

    const updateRecord = async (event) => {
        event.preventDefault();
        if (!updatedData.Name) {
            return;
        }
        try {
            await updateData('UserApi', `${updatedData.Id}`, updatedData);
            setUpdateData({
                CompanyId: 1,
            });
            //fetchtableData();
            fetchtableData();
            alert("Profile Updated Successfully")
            history.push("/Home");
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };

    const [isHovered, setIsHovered] = useState(false);

    const baseStyles = {
        width: "100%",
        padding: "10px",
        marginTop: "15px",
        borderRadius: "8px",
        border: "1px solid #fff",
        background: loading
            ? "#fff"
            : isHovered
                ? "#c5ec7bff" // light green on hover
                : "transparent",
        color: loading
            ? "#000"
            : isHovered
                ? "#000" // text turns black on hover
                : "#fff",
        fontWeight: "bold",
        cursor: loading ? "not-allowed" : "pointer",
        transition: "all 0.3s ease",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
    };


    return (
        <div
            className="max-w-md mx-auto p-6 rounded-xl shadow-lg mt-10"
            style={{
                borderRadius: '10px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                background: "#1e1e1e", // transparent white
                backdropFilter: 'blur(10px)', // optional glass effect
                WebkitBackdropFilter: 'blur(10px)', // for Safari
                marginTop: '10px',
            }}
        >
            <h2 className="text-2xl font-bold mb-4 text-center text-green-800" style={{ fontFamily: 'monospace', textTransform: 'uppercase', color: 'whitesmoke', marginTop: '-10px' }}>Edit Profile</h2>
            {/* Name */}
            <div className='m-2'>
                <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '-30px' }}>Name</label>
                <input
                    type="text"
                    name="Name"
                    required
                    className="w-full px-4 py-2 border rounded-md"
                    value={updatedData.Name}
                    onChange={handleChange}
                    placeholder='Enter your name'
                    style={{
                        width: "100%",
                        padding: "10px 10px 10px 40px",
                        borderRadius: "8px",
                        border: "1px solid #4c6793",
                        background: "#2E2E2E",
                        color: "#fff",
                        outline: "none",
                        transition: "border 0.3s ease",
                    }}
                />
            </div>

            {/* Gender */}

            <div className='m-2'>
                <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px' }}>Gender</label>
                <div className="flex space-x-4 mt-1">
                    <label className="inline-flex items-center" style={{ color: 'whitesmoke', marginTop: '5px' }}>
                        <input
                            type="radio"
                            name="Gender"
                            value="1"
                            checked={updatedData.Gender === true}
                            onChange={handleChange}
                        />
                        <span className="ml-2">Male</span>
                    </label>
                    <label className="inline-flex items-center" style={{ color: 'whitesmoke', marginLeft: '7px', marginTop: '5px' }}>
                        <input
                            type="radio"
                            name="Gender"
                            value="0"
                            checked={updatedData.Gender === false}
                            onChange={handleChange}
                        />
                        <span className="ml-2">Female</span>
                    </label>
                </div>
            </div>

            <div className='m-2'>
                <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px' }}>Contact Number</label>
                <input
                    type="text"
                    name="ContactNumber"
                    required
                    className="w-full px-4 py-2 border rounded-md"
                    value={updatedData.ContactNumber}
                    onChange={handleChange}
                    placeholder='Enter your contact number'
                    style={{
                        width: "100%",
                        padding: "10px 10px 10px 40px",
                        borderRadius: "8px",
                        border: "1px solid #4c6793",
                        background: "#2E2E2E",
                        color: "#fff",
                        outline: "none",
                        transition: "border 0.3s ease",
                    }}
                />
            </div>
            <div className='m-2'>
                <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px' }}>Email</label>
                <input
                    type="text"
                    name="Email"
                    required
                    className="w-full px-4 py-2 border rounded-md"
                    value={updatedData.Email}
                    onChange={handleChange}
                    placeholder='Enter your email'
                    style={{
                        width: "100%",
                        padding: "10px 10px 10px 40px",
                        borderRadius: "8px",
                        border: "1px solid #4c6793",
                        background: "#2E2E2E",
                        color: "#fff",
                        outline: "none",
                        transition: "border 0.3s ease",
                    }}
                />
            </div>

            {/* DOB */}
            <div className='m-2'>
                <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px' }}>Date of Birth</label>
                <input
                    type="date"
                    name="DateofBirth"
                    required
                    className="w-full px-4 py-2 border rounded-md"
                    //value={updatedData.DateofBirth}
                    value={updatedData.DateofBirth ? updatedData.DateofBirth.split('T')[0] : ''} // format to YYYY-MM-DD
                    onChange={handleChange}
                    style={{
                        width: "100%",
                        padding: "10px 10px 10px 40px",
                        borderRadius: "8px",
                        border: "1px solid #4c6793",
                        background: "#2E2E2E",
                        color: "#fff",
                        outline: "none",
                        transition: "border 0.3s ease",
                    }}
                />
            </div>

            {/* TOB */}
            <div className='m-2'>
                <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px' }}>Time of Birth</label>
                <input
                    type="time"
                    name="TimeoBirth"
                    className="w-full px-4 py-2 border rounded-md"
                    //value={formData.TimeoBirth}
                    value={updatedData.TimeoBirth || "00:00"}  // fallback to 00:00
                    onChange={handleChange}
                    required
                    style={{
                        width: "100%",
                        padding: "10px 10px 10px 40px",
                        borderRadius: "8px",
                        border: "1px solid #4c6793",
                        background: "#2E2E2E",
                        color: "#fff",
                        outline: "none",
                        transition: "border 0.3s ease",
                    }}
                />
            </div>

            {/* Place of Birth */}
            <div className='m-2'>
                <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px' }}>Place of Birth</label>
                <input
                    type="text"
                    name="PlaceofBirth"
                    required
                    className="w-full px-4 py-2 border rounded-md"
                    value={updatedData.PlaceofBirth}
                    onChange={handleChange}
                    placeholder='Enter your place of birth'
                    style={{
                        width: "100%",
                        padding: "10px 10px 10px 40px",
                        borderRadius: "8px",
                        border: "1px solid #4c6793",
                        background: "#2E2E2E",
                        color: "#fff",
                        outline: "none",
                        transition: "border 0.3s ease",
                    }}
                />
            </div>
            {/* Submit Button */}
            <div className='m-4'>

                <div className='m-4'>
                    <button
                        type="submit"
                        disabled={loading}
                        onClick={updateRecord}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                        style={baseStyles}
                    >
                        Update Profile
                    </button>

                </div>
            </div>
        </div>
    );
};

export default EditUserProfile;
